import { Button, Stack } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import useToken from '../../../helpers/useTokens'
import { GetRequest, GetRequestCachedV3, PostRequest, PostRequestCachedV3 } from '../../../common/api'
import { API_CACHE_DURATION, urls } from '../../../common/constants'
import { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'

export const PartyWiseConsignmentList = () => {
  const [partyList, setPartyList] = useState([])
  const [consginmentList, setConsginmentList] = useState([])
  const [selectedParty, setSelectedParty] = useState(null)
  const [selectedConsignments, setSelectedConsignments] = useState([])
  const { loginData } = useToken()
  const { intCompanyID } = loginData
  const [, setAlert] = useAtom(alertAtom)

  useEffect(() => {
    if (intCompanyID) {
      const obj = {
        intPartyID: 0,
        intCompanyID: intCompanyID,
        strPartyName: '',
        strContactPerson: '',
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: 0,
      }
      PostRequest(urls.getPartyList, obj).then((res) => {
        if (res.status === 'Success') {
          setPartyList(res?.Data)
        }
      })
      const payload = {
        intConsignmentSubTypeID: 0,
        intCompanyID: intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: '',
        intIsActive: 1,
        intIsDeleted: 0,
      }
      PostRequestCachedV3(urls.getConsignmentSubTypes, payload, true, API_CACHE_DURATION)
        .then((res) => {
          setConsginmentList(res?.Data || [])
        })
        .catch((err) => {
          setConsginmentList([])
        })
    }
  }, [intCompanyID])
  const getpartyConsignment = async (PartyID) => {
    const data = { CompanyID: intCompanyID, PartyID }
    const response = await GetRequest(urls.getCargoPartywiseConsignmentTypes, data)
    setSelectedConsignments(response?.Data?.Table.map((a) => ({ SubType: a.ConsignmentType, ...a })) || [])
  }
  const onSave = () => {
    if (!selectedParty?.PartyID) {
      setAlert({ show: true, msg: 'Please select a party', nextId: '', success: false })
      return
    }
    const payload = {
      CompanyID: intCompanyID,
      PartyID: selectedParty?.PartyID || 0,
      ConsignmentTypeIDs: selectedConsignments.map((a) => a.ConsignmentSubTypeID).join('^'),
    }
    PostRequest(urls.cargoPartywiseConsignmentTypesUpdate, payload).then((res) => {
      if (res.status === 'Success') {
        setAlert({ show: true, msg: 'Consignment types updated successfully', nextId: '', success: true })
      }
    })
  }
  return (
    <Stack style={{ padding: '5px 0px', display: 'flex', flexDirection: 'row', gap: '16px' }} className="itemButtons">
      <Item sx={{ display: 'flex', gap: '10px' }}>
        <DropDownOA
          data={partyList || []}
          defaultvalue={selectedParty?.Party || ''}
          value={selectedParty?.Party || ''}
          width="100%"
          dataKey={`Party`}
          idKey={`PartyID`}
          label={'Select Party'}
          searchPlaceholder={`Search Party`}
          onSelect={(value) => {
            setSelectedParty(value)
            getpartyConsignment(value.PartyID)
          }}
        />

        <DropDownMultiSelectV2
          id={'consignment-type'}
          data={consginmentList || []}
          defaultvalue={selectedConsignments}
          width="100%"
          HasAllSelect={false}
          searchPlaceholder={`Search By Report Options`}
          label={'Consignment Type'}
          tabIndex="2"
          dataKey={`SubType`}
          idKey={`ConsignmentSubTypeID`}
          listWidth="200px"
          limit={100}
          onSelect={(value) => {
            setSelectedConsignments(value)
          }}
        />

        <Button
          variant="contained"
          style={{
            width: '30%',
            height: '41px',
            backgroundColor: '#fe5200',
            fontSize: '15px',
            textTransform: 'Uppercase',
            color: '#fff',
            fontWeight: 'bold',
          }}
          onClick={() => onSave()}
        >
          Save
        </Button>
      </Item>
    </Stack>
  )
}
